import { Flex, Text, Box, Link } from "@chakra-ui/react";
import React from "react";
import { useLocation } from "react-router-dom";
import { 
  FiHome, 
  FiUsers, 
  FiSettings, 
  FiBarChart2, 
  FiDollarSign, 
  FiClock, 
  FiCalendar,
  FiMapPin,
  FiUserPlus,
  FiFileText,
  FiActivity,
  FiShield,
  FiDatabase
} from "react-icons/fi";

const SidebarBtn = ({ currentPath, text, onClick, path, icon }) => {
  const { pathname } = useLocation();
  const isActive = currentPath === path;

  // Icon mapping with more specific cases
  const getIcon = (text) => {
    // If icon is passed as prop, use it (for admin sections)
    if (icon) {
      return icon;
    }

    switch (text.toLowerCase()) {
      case "dashboard":
        return <FiHome size={18} />;
      case "employees":
        return <FiUsers size={18} />;
      case "configuration":
        return <FiSettings size={18} />;
      case "reports":
        return <FiBarChart2 size={18} />;
      case "payroll":
        return <FiDollarSign size={18} />;
      case "recent entries":
        return <FiActivity size={18} />; // Changed from FiClock
      case "leave":
      case "leave management":
        return <FiCalendar size={18} />;
      case "settings":
        return <FiShield size={18} />; // Changed from FiSettings
      case "branch management":
        return <FiMapPin size={18} />;
      case "user management":
        return <FiUserPlus size={18} />; // Changed from FiUsers
      case "overtime management":
        return <FiClock size={18} />;
      case "system settings":
        return <FiDatabase size={18} />; // Changed from FiSettings
      case "documents":
        return <FiFileText size={18} />;
      case "add employee":
        return <FiUserPlus size={18} />;
      default:
        return <FiHome size={18} />;
    }
  };

  return (
    <Link href={path} _hover={{ textDecoration: "none" }}>
      <Box>
        <Flex
          alignItems="center"
          gap={3}
          p={3}
          borderRadius="12px"
          bg={isActive ? "blue.50" : "transparent"}
          color={isActive ? "blue.600" : "gray.600"}
          _hover={{
            bg: isActive ? "blue.100" : "gray.50",
            transform: "translateX(4px)",
          }}
          transition="all 0.2s"
          cursor="pointer"
          onClick={onClick}
          borderLeft={isActive ? "3px solid" : "3px solid transparent"}
          borderLeftColor={isActive ? "blue.500" : "transparent"}
        >
          <Box
            color={isActive ? "blue.600" : "gray.500"}
            _groupHover={{ color: "blue.600" }}
          >
            {getIcon(text)}
          </Box>
          <Text
            fontSize="sm"
            fontWeight={isActive ? "600" : "500"}
            color={isActive ? "blue.600" : "gray.700"}
          >
            {text}
          </Text>
        </Flex>
      </Box>
    </Link>
  );
};

export default SidebarBtn;
